
type Props = {}

const PageUser = (props: Props) => {
  return (
    <div>PageUser</div>
  )
}

export default PageUser